/**
 * Ajuda dos campos do corretor e do cadastro da propria corretora.
 *
 * Juntada em `../ajudaDosCampos.ts`, que explica a chave e o texto. Ver
 * docs/FRONTEND.md, secao 6.
 */
export const ajuda: Record<string, Record<string, string>> = {
  '/corretores': {
    CNPJ: 'O servidor confere os digitos verificadores. Com o CNPJ completo, a Receita Federal (SeguraCoreData) preenche os campos vazios; o que ja foi digitado so muda se voce confirmar.',
    'Codigo SUSEP': 'Registro do corretor na SUSEP.',
    'Situacao cadastral externa':
      'Resultado da consulta ao registro externo: nao consultado, regular, irregular ou nao encontrado. E separada da etapa interna de ativacao e, sem integracao, e registrada a mao.',
    'Comissao (%)':
      'Comissao acordada com o corretor, entre 0 e 100. A comissao de cada negocio e informada na propria operacao.',
    'Forma de recebimento':
      'Tipo da chave Pix do repasse. Forma e chave andam juntas: uma sem a outra e recusada. So quem tem a permissao de alterar dados bancarios da corretora muda o Pix.',
    'Chave de recebimento':
      'Chave Pix para o repasse da comissao. Forma e chave andam juntas: uma sem a outra e recusada. So quem tem a permissao de alterar dados bancarios da corretora muda o Pix.',
    'Comercial responsavel':
      'Pessoa da empresa que cuida da conta. Texto livre: nao precisa ter acesso a plataforma.',
    Conta:
      'Conta que recebe o repasse da comissao, sem o digito. So quem tem a permissao de alterar dados bancarios da corretora troca a conta, e a troca fica na trilha com a conta anterior.',

    // Ficha completa do corretor (P-COR-1).
    'Limite de comissao (%)':
      'Comissao maxima declarada para o corretor. E registrada e nao trava a comissao da operacao: a regra do limite ainda nao foi homologada. So quem tem a alcada da comissao altera.',
    'Situacao do CNPJ':
      'Situacao na Receita Federal. Registrada a mao ate haver consulta automatica; a data do registro fica gravada.',
    'Codigo CNAE':
      'Subclasse da CNAE, sete digitos, do catalogo da plataforma. A descricao aparece abaixo do campo.',
    'Data expiracao do cadastro':
      'Data em que o cadastro vence. A tela avisa quando passou, mas nada e bloqueado: a validade e o recadastro sao regra pendente da seguradora.',
    'Situacao SUSEP':
      'Situacao do registro na SUSEP. Regular corresponde a Ativo. Registrada a mao ate haver consulta.',
    Canal:
      'Canal de venda da corretora, do catalogo em Configuracoes. O canal que pede os codigos da seguradora exige o codigo do corretor, da sucursal e do contrato.',
    'Level corretor':
      'Nivel do corretor. Texto livre: a seguradora ainda nao informou o que ele significa nem quais valores aceita.',
    'Administrador do portal':
      'Pessoa da propria corretora que define os usuarios dela no portal.',
    'Justificativa de bloqueio':
      'Motivo do bloqueio, exigido para bloquear. Fica no cadastro enquanto o bloqueio vale e no historico depois.',
    'Nome do Corretor': 'Procura na razao social e no nome fantasia.',
    'CNPJ Corretor': 'Procura pelos digitos do CNPJ, com ou sem mascara.',

    // Assistente de cadastro de corretor (P-COR-2).
    'Numero SUSEP': 'Registro do corretor na SUSEP.',
    'Recadastramento SUSEP':
      'Data do recadastramento do corretor na SUSEP. Fica registrada: a validade e o recadastro sao regra pendente da seguradora, e nada e bloqueado.',
    'Perfil do administrador':
      'Perfil da corretora que o administrador do portal recebe ao aceitar o convite. Vem o Administrador da Corretora, que define os usuarios dela.',
    'Tipo de perfil':
      'Perfil da corretora que o usuario recebe ao aceitar o convite. So aparecem os perfis da corretora que voce pode conceder.',
    'Celular do usuario':
      'Opcional, com DDD. Fica no convite e, no aceite, no cadastro da pessoa.',

    // Limite de consultas e validacao de comissao (P-COR-3).
    'Quantidade de consultas':
      'Consultas a bureau da corretora no periodo. Com o bloqueio automatico ligado, o limite atingido recusa a consulta nova; com ele desligado, o limite so informa.',
    Periodo:
      'Janela da contagem, no horario de Brasilia: o dia ou o mes corrente. A contagem recomeca no periodo seguinte.',
    'Justificativa do desbloqueio':
      'Motivo do desbloqueio, exigido. Fica no limite e no historico, com quem desbloqueou. O desbloqueio vale ate o fim do periodo.',
    'Taxa a validar (%)':
      'Taxa de comissao comparada com o Limite de comissao do corretor, com ate duas casas. So informa o resultado: nada e bloqueado.',
  },

  // Assessorias (P-COR-3). O detalhe /assessorias/:id/corretores herda daqui.
  '/assessorias': {
    'Nome da assessoria':
      'Nome que identifica a assessoria na lista e nas corretoras dela.',
    'CNPJ da assessoria':
      'Opcional. Informado, precisa ter digitos verificadores validos e ser unico na empresa.',
    'Comissao da assessoria (%)':
      'Comissao da assessoria sobre a corretora, so registrada: a base, o limite e quem aprova ainda nao foram definidos. Pede a alcada da comissao.',
  },

  '/corretora': {
    Conta:
      'Conta que recebe o repasse da comissao, sem o digito. A troca exige a permissao de alterar dados bancarios, que a seguradora concede; sem ela, a conta fica so de leitura.',
  },
};
